import { render } from "./DouyinPremiumCard.vue?vue&type=template&id=f480f2fe&scoped=true"
import script from "./DouyinPremiumCard.vue?vue&type=script&lang=js"
export * from "./DouyinPremiumCard.vue?vue&type=script&lang=js"

import "./DouyinPremiumCard.vue?vue&type=style&index=0&id=f480f2fe&lang=less&scoped=true"

import exportComponent from "/Users/rppig42/Code/dbkf/uworker-mobile/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.2.21_vue@3.2.21_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f480f2fe"]])

export default __exports__